/**
 * Created with IntelliJ IDEA.
 * User: elanh
 * Date: 2/21/13
 * Time: 5:38 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var Marionette = require("marionette");
    var UserBarLayout = require("layouts/UserBarLayout");
    var PersonaSwitcher = require("views/PersonaSwitcher");
    var PersonaModel = require("models/PersonaModel");
    var TrayMenuItemModel = require("models/TrayMenuItemModel");
    var TopLevelMenu = require("views/top-level-menu/TopLevelMenu");
    var CONST = require("const");
    var Backbone = require("backbone");
    var SelectableCollectionDecorator = require("decorators/SelectableCollectionDecorator");
    var LiveEngageUserBarMenuController = require("controllers/LiveEngageUserBarMenuController");

    /*
     this controller is responsible for controlling the different components of the LiveEngage application
     on start, it displays the LiveEngage layout and sets all its sub-regions
     */
    var LiveEngageUserBarController = Marionette.Controller.extend({
        initialize : function (options) {
            this.LE = options.application;
            this.moduleRegions = options.moduleRegions;

            this.userBarLayout = new UserBarLayout();
            this.liveEngageUserBarMenuController = new LiveEngageUserBarMenuController({
                application : options.application
            });
        },
        show : function (options) {
            this.listenTo(this.userBarLayout, "render", function () {
                var collection = new Backbone.Collection();
                collection.comparator = function (item) {
                    return item.get("switcherIndex");
                };

                _.each(this.moduleRegions, function(region, key) {
                    if (region.switcherControl) {
                        collection.add(new PersonaModel({
                            type : region.persona,
                            className : region.switcherControl,
                            relatedModuleName : key,
                            switcherIndex :region.switcherIndex,
                            tooltip : _.isUndefined(CONST.DEFAULT_PERSONA_TOOLTIP_MAP[region.persona]) ? "" : this.LE.translator.translate(CONST.DEFAULT_PERSONA_TOOLTIP_MAP[region.persona]),
                            itemTitle : this.LE.translator.translate(CONST.PERSONA_TITLE[region.persona])
                        }));
                    }
                }, this);

                this.personaSwitcher = new PersonaSwitcher({ application : this.LE, collection : SelectableCollectionDecorator.decorate(collection)});
                this.userBarLayout.personaSwitcher.show(this.personaSwitcher);

                this.liveEngageUserBarMenuController.show({
                    layout: this.userBarLayout,
                    topLevelMenu : this.userBarLayout.topLevelMenu,
                    trayMenu : this.userBarLayout.trayMenu,
                    userBarWidgets:this.userBarLayout.userBarWidgets
                });

            });

            // Handle sound controller events
            this.listenTo(LE.soundController, "change", this._onSoundStateChange);

            options.containerRegion.show(this.userBarLayout);
        },
        setViewedWorkarea : function (switcherControl) {
            this.personaSwitcher.setSwitcher(switcherControl);
        },
        _onSoundStateChange: function(model) {
            if(model.get("enabled")) {
                if(this.muteTrayItem) {
                    LE.userBarMenu.removeTrayItem(this.muteTrayItem);
                }
            } else {
                this.muteTrayItem = new TrayMenuItemModel({
                    iconClass: ".sound-icon-tray-off",
                    index: 2,
                    tooltip: LE.translator.translate("LEFramework.userBarMenu.menuItemTray.sound.off.tooltip")
                });
                LE.userBarMenu.addTrayItem(this.muteTrayItem);
            }
        }//,

//        openPersonaModule: function (options) {
//            var switcherControl = this.MODULES_WRAPPERS[options.persona] || this.getPersonaSwitcherControlEL(options.persona);
//            if(switcherControl){
//                setViewedWorkarea(switcherControl);
//            }
//        },
//        getPersonaSwitcherControlEL: function (persona) {
//            var switcherControlEL;
//            var moduleWrapper = CONST.PERSONA_TO_MODULE_WRAPPER[persona];
//
//            if (moduleWrapper && moduleWrapper.switcherControl) {
//                var tempSelector = $(moduleWrapper.switcherControl);
//                if (tempSelector && tempSelector.length > 0) {
//                    switcherControlEL =  this.MODULES_WRAPPERS[persona] = tempSelector[0];
//                }
//            }
//            return switcherControlEL;
//        }
    });
    return LiveEngageUserBarController;
});
